import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import {withRouter} from "react-router-dom";

import LeadTable from "./LeadTable";

class RemarketingList extends Component {

    render() {
        document.title ="Remarketing | CLTV Cloud";

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Remarketing" pageTitle="CLTV Cloud"/>
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <LeadTable remarketing/>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(RemarketingList);
